import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { X, ShoppingBag } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { formatPrice, mediaUrl } from "../lib/api";

export default function Cart() {
  const { cart, removeFromCart, cartSubtotal } = useStore();
  const navigate = useNavigate();

  if (cart.length === 0) return (
    <div className="luxy-container py-24 text-center" data-testid="cart-empty-state">
      <ShoppingBag className="w-12 h-12 mx-auto text-stonemuted mb-5" strokeWidth={1} />
      <h1 className="font-serif text-3xl text-pitch">Your bag is empty</h1>
      <p className="text-stonemuted mt-3">Discover one-of-one pieces from the archive.</p>
      <Link to="/shop" className="inline-block mt-8 bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] px-8 py-4">Continue Shopping</Link>
    </div>
  );

  return (
    <div className="luxy-container py-12 sm:py-16">
      <h1 className="font-serif text-4xl text-pitch tracking-tight mb-10">Shopping Bag</h1>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-12">
        <div className="divide-y divide-linen border-t border-linen">
          {cart.map((item) => (
            <div key={item.product_id} className="flex gap-5 py-6" data-testid="cart-page-item">
              <Link to={`/product/${item.snapshot.slug}`} className="w-28 h-36 bg-bone shrink-0 overflow-hidden">
                {item.snapshot.image && <img src={mediaUrl(item.snapshot.image)} alt="" className="w-full h-full object-cover" />}
              </Link>
              <div className="flex-1 flex flex-col">
                <div className="text-[11px] font-mono uppercase tracking-widest text-stonemuted">{item.snapshot.brand}</div>
                <Link to={`/product/${item.snapshot.slug}`} className="font-serif text-xl text-pitch mt-1 hover:text-champagne-dark transition-colors">{item.snapshot.title}</Link>
                <div className="text-xs text-stonemuted mt-1">Quantity: 1 (one of one)</div>
                <div className="mt-auto flex items-center justify-between">
                  <span className="font-medium">{formatPrice(item.snapshot.price, item.snapshot.currency)}</span>
                  <button onClick={() => removeFromCart(item.product_id)} data-testid="cart-page-remove"
                    className="text-stonemuted hover:text-vermilion transition-colors inline-flex items-center gap-1 text-xs uppercase tracking-widest">
                    <X className="w-4 h-4" /> Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-bone p-8 h-fit lg:sticky lg:top-28">
          <h2 className="eyebrow mb-6">Order Summary</h2>
          <div className="flex justify-between text-sm py-2"><span className="text-stonemuted">Subtotal</span><span className="font-medium">{formatPrice(cartSubtotal)}</span></div>
          <div className="flex justify-between text-sm py-2 border-b border-linen"><span className="text-stonemuted">Shipping</span><span>Calculated at checkout</span></div>
          <div className="flex justify-between text-base py-4 font-medium"><span>Estimated Total</span><span>{formatPrice(cartSubtotal)}</span></div>
          <button onClick={() => navigate("/checkout")} data-testid="cart-page-checkout"
            className="w-full bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-charcoal transition-colors mt-2">Proceed to Checkout</button>
          <Link to="/shop" className="block text-center text-xs uppercase tracking-[0.2em] mt-4 text-charcoal">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
